// todo: we should modify this optional conditions next time ( "src" and "googleIndex" should be deleted )
const generalOptionals = [
    "src",
    "googleIndex",
    "snapshot",
    "fullscreen",
    "autoplay",
    "t",
    "h",
    "theme",
    "provider",
    "fullrate",
    "e-cover",
    "cover",
    "uid",
    "user_id",
    "user_ids",
    "preview",
    "isAuth",
    "authentication",
    "site",
    "xToken",
    "width",
    "height",
    "chart",
    "onFinished",
    "showModuleTitle",
    "scrollElementId",
    "onSnapshot",
    "isMarkersChange",
    "featureSet",
    "uuid",
    "handleRedirectCards",
    "homeButtonClickFlag"
];

export const allParams = [
    "src",
    "type",
    "id",
    "fullscreen",
    "autoplay",
    "portrait",
    "t",
    "h",
    "isGeneral",
    "raw",
    "theme",
    "provider",
    "fullrate",
    "snapshot",
    "cover",
    "user_id",
    "user_ids",
    "preview",
    "isAuth",
    "authentication",
    "site",
    "e-url",
    "e-cover",
    "width",
    "height",
    "chart",
    "onFinished",
    "shoiwModuleTitle",
    "scrollElementId",
    "onSnapshot",
    "isMarkersChange",
    "quiz",
    "featureSet",
    "uuid",
    "homeButtonClickFlag"
];

export const quizConditions = {
    requireds: ["type", "quiz", "id"],
    optionals: [...generalOptionals]
};

export const isGeneralConditions = {
    requireds: ["type", "isGeneral", "src"],
    optionals: [...generalOptionals, "portrait"]
};

export const staticConditions = {
    requireds: ["e-url", "type"],
    optionals: [...generalOptionals]
};

export const nonStaticConditions = {
    requireds: ["id", "type"],
    optionals: [...generalOptionals, "portrait"]
};

export const rawConditions = {
    requireds: ["raw", "type", "id"],
    optionals: [...generalOptionals, "portrait"]
};
